<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <div>
      <div class="container mt-5 pt-5" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: green;font-family: Open Sans, sans-serif;font-size:25px!important;">
            <span><v-icon class="mr-1" color="green">&#xe92d;</v-icon></span>
            <span style="padding-top: 2px">{{ $t('kyc.thanks_you_title') }}</span>
          </p>
        </div>

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA;padding-top: 40px!important">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../../assets/img/assuraf_lg.png" width="80" alt="assuraf_logo">
                                </div>
                              </div>
                                <i class="fa fa-check-circle mt-5" aria-hidden="true"></i>
                                <h2>{{ $t('kyc.thanks_you_content[0]') }}</h2>
                                <p>{{ $t('kyc.thanks_you_content[1]') }}
<br>
                                  {{ $t('kyc.thanks_you_content[2]') }}<br><br>
                                  </p> 
                                  

                                  
                                  

                                  </div>
                            </div> 
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE       ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="mt-5 row" style="background:#FAFAFA;padding-top: 30px!important">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../../assets/img/assuraf_lg.png" width="80" alt="assuraf_logo">
                                </div>
                              </div>
                                <i class="fa fa-check-circle mt-5" aria-hidden="true"></i>
                                <h2>{{ $t('kyc.thanks_you_content[0]') }}</h2>
                                <p>{{ $t('kyc.thanks_you_content[1]') }}<br>
                                  {{ $t('kyc.thanks_you_content[2]') }}<br>
                                  </p> 
                            </div> 
                        </div>    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
    };
  },
  methods: {
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/button.css";
@import "../../assets/css/devis_css.css";
@import "../../assets/css/assurcare/form_assurcare.css";

.rowBanner {
  padding: auto;
  background-image: url("../../assets/img/thankPagesSocialIcon/banner.png  ");
  background-size: 100% 100%;
  height: auto;
  opacity: 2;
}

.rowBanner-mobile {
  padding: auto;
  background-image: url("../../assets/img/thankPagesSocialIcon/banner-mobile.png  ");
  background-size: 100% 100%;
  height: auto;
  opacity: 2;
}

.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}

.row-container {
  background: white;
}

.border-radius {
  border-radius: 20px;
}

.georgia {
  font-family: Georgia !important;
}






._failed{ border-bottom: solid 4px red !important; }
._failed i{  color:red !important;  }

._success {
  background-color: rgb(255, 251, 246);;
    border-radius: 10px;
    box-shadow: 0 15px 25px #00000019;
    padding: 45px;
    width: 100%;
    text-align: center;
    margin: 40px auto;
    // border-bottom: solid 4px #28a745;
    border-bottom: solid 4px #ffa409;
}

._success i {
    font-size: 55px;
    color: #28a745;
}

._success h2 {
    margin-bottom: 12px;
    font-size: 30px;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 10px;
}

._success p {
    margin-bottom: 0px;
    font-size: 15px;
    color: #000;
    font-weight: 500;
}
.attestation-content {
    border: 1px solid;
    padding: 15px;
    border-radius: 10px;
    background: #fff;
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>

